import { Link } from 'react-router-dom';
import { OVERVIEW_COPY, type TemplatePartCopy } from '../agents-copy';
import styles from './TemplatePartRow.module.css';

interface TemplatePartRowProps {
  part: TemplatePartCopy;
  linkLabel: string;
  to?: string;
}

/** One kind of thing a template is built from, with a link to where the partner manages it. */
export const TemplatePartRow = ({ part, linkLabel, to }: TemplatePartRowProps) => (
  <li className={styles.part}>
    <h4>
      {part.title}
      <span>{part.tagline}</span>
    </h4>
    <p>{part.description}</p>
    <dl>
      <dt>{OVERVIEW_COPY.exampleLabel(part.examples.length)}</dt>
      {part.examples.map(example => (
        <dd key={example}>{example}</dd>
      ))}
    </dl>
    {to && <Link to={to}>{linkLabel}</Link>}
  </li>
);
